import { ICacheContext } from 'framework/context/ICacheContext';
import { ITruckDto } from 'gen/ApiClient';
import React from 'react';

export const TrucksCacheContext = React.createContext<ICacheContext<ITruckDto[]>>(undefined as any);